<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '0px', fullScreenBackdrop: true }"></ngx-loading>

<section>
    <div class="card">
        <div class="card-header"> 
            <div class="option-export" *ngIf="false">
                <span title="Exporter au format Excel" (click)="ExportRapportConfirm()">
                    Exporter
                    <i *ngIf="loader" class="fa fa-refresh fa-spin"></i>
                    <i *ngIf="!loader" class="fa fa-download"></i>
                </span>
            </div>
            <i class="fa fa-plus-circle add" aria-hidden="true">
                <span (click)="openPlanningModal()"> Ajouter </span>
            </i>
        </div>
        <div class="card-body p-0">
            <div class="app">
                <div class="main">
                    <div class="container p-0">
                        <div class="row">
                            <div class="col-md-3 messages">
                                <form>
                                    <div class="inner-addon left-addon">
                                        <i class="fa fa-search"></i>
                                        <input type="search" class="search" placeholder="Rechercher..."
                                            [(ngModel)]="searchText" name="searchTerm"
                                            (ngModelChange)="filterTrucks()" />
                                    </div>
                                </form>
                                <ul class="message-list">
                                    <li *ngFor="let truck of filterTrucks()"
                                        [ngClass]="{'active': selectedTruck?.id === truck.id}"
                                        (click)="selectedTruck = truck">
                                        <div class="preview">
                                            <h5>
                                                {{ truck.label }}
                                                <small>{{ truck.updatedAt | date:'dd-MM-yy' }}</small>
                                            </h5>
                                            <p>Véhicule {{ truck.matricule }}</p>
                                            <p>Jours Planifiés: {{ getPlannedDays(truck.missions) }}</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-9">
                                <section *ngIf="selectedTruck" class="message">
                                    <h3>{{ selectedTruck.matricule }}</h3>
                                    <div class="option-add">
                                        <span title="Modifier" (click)="editPlanning(selectedTruck)">
                                            <i class="fa fa-edit"></i> Modifier
                                        </span>
                                    </div>
                                    <div class="option-delete">
                                        <span title="Supprimer" (click)="onConfirmDelete()">
                                            <i class="fa fa-minus-circle"></i> Supprimer
                                        </span>
                                    </div>
                                    <div class="option-export">
                                        <span title="Exporter" (click)="ExportRapportConfirm()">
                                            <i *ngIf="loading" class="fa fa-refresh fa-spin"></i>
                                            <i *ngIf="!loading" class="fa fa-download"></i>
                                            Exporter
                                        </span>
                                    </div>                                                                        

                                    <div class="meta-data">
                                        <table class="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Date mise à jour</th>
                                                    <th>Jours Planifiés</th>
                                                    <th>Label</th>
                                                    <th>Date Début</th>
                                                    <th>Date Fin</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{{ selectedTruck.updatedAt | date:'dd-MM-yy, HH:mm' }}</td>
                                                    <td>{{ getPlannedDays(selectedTruck.missions) }}</td>
                                                    <td>{{ selectedTruck.label || '-' }}</td>
                                                    <td>{{ selectedTruck.dateDebut | date:'dd-MM-yy, HH:mm' || '-' }}
                                                    </td>
                                                    <td>{{ selectedTruck.dateFin | date:'dd-MM-yy, HH:mm' || '-' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="body">
                                        <div class="panel-group" id="accordion">
                                            <div *ngFor="let day of days; let i = index" class="panel panel-default">
                                                <div class="panel-heading">
                                                    <h4 class="panel-title">
                                                        <a data-toggle="collapse" data-parent="#accordion"
                                                            href="#panel{{i}}">
                                                            {{ day | dayTranslate }} :
                                                            <b>{{ getMissionLabel(selectedTruck.missions[day]) }}</b>
                                                        </a>
                                                    </h4>
                                                </div>
                                                <div class="panel-collapse collapse" id="panel{{i}}">
                                                    <div class="panel-body">
                                                        <span class="badge" style="margin: 10px;"
                                                            [ngStyle]="{'background-color': getMissionColor(selectedTruck.missions[day])}">
                                                            {{ getMissionLabel(selectedTruck.missions[day]) }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- PLANNING MODAL -->
<div class="modal fade" bsModal #planningModal="bs-modal" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg" style="-webkit-transform: translate(0, 0);">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="closePlanningModal()">×</button>
                <h4 class="modal-title">
                    <i class="fa fa-plus-circle" *ngIf="mode === 'ADD'" aria-hidden="true"></i>
                    <i class="fa fa-edit" *ngIf="mode === 'UPDATE'"></i>
                    {{ mode === 'ADD' ? 'Nouvelle Planification' : 'Modifier Planification' }}
                </h4>
            </div>
            <div class="modal-body">
                <div class="box-body">
                    <form>
                        <!-- Label -->
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-sm-2 control-label">Label</label>
                                <div class="col-sm-10">
                                    <input class="form-control" type="text" name="label" [(ngModel)]="newPlanning.label"
                                        required autocomplete="off" />
                                </div>
                            </div>
                        </div>
                        <!-- Groupe and Véhicule -->
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="col-sm-2 control-label">Groupe</label>
                                <div class="col-sm-10">
                                    <ng-select [items]="groupsItems" [(ngModel)]="selectedGroupsItems"
                                        [multiple]="false" bindLabel="text" bindValue="id"
                                        (change)="selectedGroups($event)" [compareWith]="compareGroups"
                                        [clearable]="true" placeholder="Aucun groupe sélectionné" name="group">
                                    </ng-select>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label class="col-sm-2 control-label">Véhicule</label>
                                <div class="col-sm-10">
                                    <ng-select [items]="vehiculesItems" [(ngModel)]="vehiculesSelected"
                                        [multiple]="false" bindLabel="matricule" bindValue="id"
                                        (change)="selectedVehicules($event)" [compareWith]="compareVehicules"
                                        [clearable]="true" placeholder="Aucun véhicule sélectionné" name="vehicule">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <!-- Date and Citerne -->
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="col-sm-2 control-label">Date</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control input-sm" id="dateDebut" bsDatepicker
                                        name="dateDebut" [(ngModel)]="planificationAssignmentAddDto.dateDebut"
                                        [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY, HH:mm', containerClass: 'theme-dark-blue' }"
                                        [minDate]="maxDate" placement="bottom" autocomplete="off"
                                        (ngModelChange)="onChangeStartDate()" required>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label class="col-sm-2 control-label">Citerne</label>
                                <div class="col-sm-10">
                                    <input [(ngModel)]="vehiculesSelected.subMark" name="subMark" type="text"
                                        placeholder="Remorque" class="form-control" *ngIf="vehiculesSelected" />
                                    <input *ngIf="!vehiculesSelected" name="subMark" type="text" placeholder="Remorque"
                                        class="form-control" disabled />
                                </div>
                            </div>
                        </div>
                        <!-- Days -->
                        <div class="row">
                            <div *ngFor="let day of days" class="col-md-6 form-group">
                                <label class="capitalize">{{ day | dayTranslate }}</label>
                                <select [(ngModel)]="newPlanning.missions[day]" [ngModelOptions]="{standalone: true}"
                                    class="form-control">
                                    <option [ngValue]="null" style="color: rgba(255, 0, 0, 0.367);">Aucune mission
                                    </option>
                                    <option *ngFor="let mission of availableMissions" [ngValue]="mission.id">{{
                                        mission.label }}</option>
                                </select>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="modal-footer">
                <button (click)="closePlanningModal()" class="btn btn-default pull-right">Fermer</button>
                <button (click)="savePlanning()" class="btn btn-primary pull-right" style="margin-right: 10px;"
                    [disabled]="!isFormValid()">Enregistrer</button>
            </div>
        </div>
    </div>
</div>

<!-- DELETE MODAL -->
<div class="modal fade" bsModal #truckDeleteModal="bs-modal" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="truckDeleteModal.hide()">×</button>
                <h4 class="modal-title">
                    <i class="fa fa-cogs" aria-hidden="true"></i> Êtes-vous sûr ?
                </h4>
            </div>
            <div class="modal-body">
                <div class="alert alert-danger alert-dismissible" style="border-radius: 0px; text-align: center">
                    <h4 style="color: white">
                        <i class="fa fa-exclamation-triangle"></i> Suppression !
                    </h4>
                    <span>Êtes-vous sûr de supprimer la planification du camion ?</span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="truckDeleteModal.hide()">Annuler</button>
                <button type="button" class="btn btn-success" (click)="onDelete()">
                    <i class="fa fa-check" aria-hidden="true" *ngIf="!loading"></i>
                    <i class="fa fa-spinner fa-spin" *ngIf="loading"></i> Oui, Je confirme
                </button>
            </div>
        </div>
    </div>
</div>

<!-- GENERATE REPORT MODAL -->
<div class="modal fade" bsModal #truckGenerateModal="bs-modal" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="truckGenerateModal.hide()">×</button>
                <h4 class="modal-title">
                    <i class="fa fa-cogs" aria-hidden="true"></i> Générer un rapport de planification par période
                </h4>
            </div>
            <div class="modal-body">
                <p style="font-weight: bold;">Veuillez sélectionner une période :</p>
                <div class="row">
                    <div class="form-group col-md-6">
                        <label class="col-sm-2 control-label" style="color: limegreen">Du</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control input-sm" bsDatepicker name="startDate"
                                [(ngModel)]="repport.dateInterval.startDate"
                                [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', containerClass: 'theme-dark-blue' }"
                                [maxDate]="maxDate" placement="bottom" autocomplete="off" />
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="col-sm-2 control-label" style="color: limegreen">Au</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control input-sm" bsDatepicker name="endDate"
                                [(ngModel)]="repport.dateInterval.endDate"
                                [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', containerClass: 'theme-dark-blue' }"
                                [maxDate]="maxDate" placement="bottom" autocomplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="truckGenerateModal.hide()">Annuler</button>
                <button type="button" class="btn btn-success" (click)="exportExel()">
                    <i class="fa fa-check" *ngIf="!loading"></i>
                    <i class="fa fa-spinner fa-spin" *ngIf="loading"></i> Exporter
                </button>
            </div>
        </div>
    </div>
</div>
<!-- PLANNING MODAL -->
<div class="modal fade" bsModal #planningModal="bs-modal" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="closePlanningModal()">×</button>
                <h4 class="modal-title">
                    <i class="fa fa-plus-circle" *ngIf="mode === 'ADD'" aria-hidden="true"></i>
                    <i class="fa fa-edit" *ngIf="mode === 'UPDATE'"></i>
                    {{ mode === 'ADD' ? 'Nouvelle Planification' : 'Modifier Planification' }}
                </h4>
            </div>
            <div class="modal-body">
                <div class="box-body">
                    <form>
                        <!-- Label -->
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-sm-2 control-label">Label</label>
                                <div class="col-sm-10">
                                    <input class="form-control" type="text" name="label" [(ngModel)]="newPlanning.label"
                                        required autocomplete="off" />
                                </div>
                            </div>
                        </div>
                        <!-- Groupe and Véhicule -->
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="col-sm-2 control-label">Groupe</label>
                                <div class="col-sm-10">
                                    <ng-select [items]="groupsItems" [(ngModel)]="selectedGroupsItems"
                                        [multiple]="false" bindLabel="text" bindValue="id"
                                        (change)="selectedGroups($event)" [compareWith]="compareGroups"
                                        [clearable]="true" placeholder="Aucun groupe sélectionné" name="group">
                                    </ng-select>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label class="col-sm-2 control-label">Véhicule</label>
                                <div class="col-sm-10">
                                    <ng-select [items]="vehiculesItems" [(ngModel)]="vehiculesSelected"
                                        [multiple]="false" bindLabel="matricule" bindValue="id"
                                        (change)="selectedVehicules($event)" [compareWith]="compareVehicules"
                                        [clearable]="true" placeholder="Aucun véhicule sélectionné" name="vehicule">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <!-- Date and Citerne -->
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="col-sm-2 control-label">Date</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control input-sm" id="dateDebut" bsDatepicker
                                        name="dateDebut" [(ngModel)]="planificationAssignmentAddDto.dateDebut"
                                        [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY, HH:mm', containerClass: 'theme-dark-blue' }"
                                        [minDate]="maxDate" placement="bottom" autocomplete="off"
                                        (ngModelChange)="onChangeStartDate()" required>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label class="col-sm-2 control-label">Citerne</label>
                                <div class="col-sm-10">
                                    <input [(ngModel)]="vehiculesSelected.subMark" name="subMark" type="text"
                                        placeholder="Remorque" class="form-control" *ngIf="vehiculesSelected" />
                                    <input *ngIf="!vehiculesSelected" name="subMark" type="text" placeholder="Remorque"
                                        class="form-control" disabled />
                                </div>
                            </div>
                        </div>
                        <!-- Days -->
                        <div class="row">
                            <div *ngFor="let day of days" class="col-md-6 form-group">
                                <label class="capitalize">{{ day | dayTranslate }}</label>
                                <select [(ngModel)]="newPlanning.missions[day]" [ngModelOptions]="{standalone: true}"
                                    class="form-control">
                                    <option [ngValue]="null" style="color: rgba(255, 0, 0, 0.367);">Aucune mission
                                    </option>
                                    <option *ngFor="let mission of availableMissions" [ngValue]="mission.id">{{
                                        mission.label }}</option>
                                </select>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="modal-footer">
                <button (click)="closePlanningModal()" class="btn btn-default pull-right">Fermer</button>
                <button (click)="savePlanning()" class="btn btn-primary pull-right" style="margin-right: 10px;"
                    [disabled]="!isFormValid()">Enregistrer</button>
            </div>
        </div>
    </div>
</div>

<!-- DELETE MODAL -->
<div class="modal fade" bsModal #truckDeleteModal="bs-modal" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="truckDeleteModal.hide()">×</button>
                <h4 class="modal-title">
                    <i class="fa fa-cogs" aria-hidden="true"></i> Êtes-vous sûr ?
                </h4>
            </div>
            <div class="modal-body">
                <div class="alert alert-danger alert-dismissible" style="border-radius: 0px; text-align: center">
                    <h4 style="color: white">
                        <i class="fa fa-exclamation-triangle"></i> Suppression !
                    </h4>
                    <span>Êtes-vous sûr de supprimer la planification du camion ?</span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="truckDeleteModal.hide()">Annuler</button>
                <button type="button" class="btn btn-success" (click)="onDelete()">
                    <i class="fa fa-check" aria-hidden="true" *ngIf="!loading"></i>
                    <i class="fa fa-spinner fa-spin" *ngIf="loading"></i> Oui, Je confirme
                </button>
            </div>
        </div>
    </div>
</div>

<!-- GENERATE REPORT MODAL -->
<div class="modal fade" bsModal #truckGenerateModal="bs-modal" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="truckGenerateModal.hide()">×</button>
                <h4 class="modal-title">
                    <i class="fa fa-cogs" aria-hidden="true"></i> Générer un rapport de planification par période
                </h4>
            </div>
            <div class="modal-body">
                <p style="font-weight: bold;">Veuillez sélectionner une période :</p>
                <div class="row">
                    <div class="form-group col-md-6">
                        <label class="col-sm-2 control-label" style="color: limegreen">Du</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control input-sm" bsDatepicker name="startDate"
                                [(ngModel)]="repport.dateInterval.startDate"
                                [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', containerClass: 'theme-dark-blue' }"
                                [maxDate]="maxDate" placement="bottom" autocomplete="off" />
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="col-sm-2 control-label" style="color: limegreen">Au</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control input-sm" bsDatepicker name="endDate"
                                [(ngModel)]="repport.dateInterval.endDate"
                                [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', containerClass: 'theme-dark-blue' }"
                                [maxDate]="maxDate" placement="bottom" autocomplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="truckGenerateModal.hide()">Annuler</button>
                <button type="button" class="btn btn-success" (click)="exportExel()">
                    <i class="fa fa-check" *ngIf="!loading"></i>
                    <i class="fa fa-spinner fa-spin" *ngIf="loading"></i> Exporter
                </button>
            </div>
        </div>
    </div>
</div>
